import styled from 'styled-components';
import {dFlex, dFlexColumn} from '../../../../../../globalVariables/GlobalFlex';
import {mobileMedia, scrollbar, WHITE} from '../../../../../../globalVariables/GlobalVariables';

export const table = styled.div`
    width: 100%;
    height: calc(100% - 200px);
`;

export const tableHeader = styled.div`
    ${dFlex}
    background: ${WHITE};
    font-weight: 600;
    padding-inline: 20px;
`;

export const headerCell = styled.div`
    padding: 10px 8px;
    font-weight: 600;
    text-align: center;
    flex: 1;
`;

export const tableBody = styled.div`
    ${dFlexColumn}
    height: calc(100% - 40px);
    ${scrollbar}
    padding-inline: 30px;
    ${mobileMedia}{
        height: 100%;
        padding-inline: 10px;
    }
`;
